export const ValidateMessage = {
  REQUERIDO: "Campo requerido",
  INVALIDATE_DATE: "Debe ser un fecha válida",
  INVALIDATE_NUMBER: "Debe ser numerico",
  MAX: "Debe tener como máximo :max carácteres",
  CORREO: "Debe ser un correo válido",
};
